import Marquee from "react-fast-marquee";
import { MARQUEE_ITEMS } from "../data";

export const SiteMarquee = () => (
  <div className="border-y border-gold/10 bg-panel py-5" data-testid="editorial-marquee">
    <Marquee speed={35} gradient={false} pauseOnHover>
      {MARQUEE_ITEMS.map((t) => (
        <span
          key={t}
          className="mx-8 inline-flex items-center gap-8 font-display text-sm sm:text-base font-semibold uppercase tracking-[0.2em] text-cream/60"
        >
          {t}
          <span className="text-copper text-xs">◆</span>
        </span>
      ))}
    </Marquee>
  </div>
);
